import { useContext } from 'react';
import { PageTitleContext } from './page-title-context';

export function usePageTitle() {
  return useContext(PageTitleContext);
}
